import React, { useEffect, useState } from 'react';
import { FormInstance } from 'antd';
import ClientSelectSearch from 'components/ClientSelectSearch';
import LocationSelectSearch from 'components/LocationSelectSearch';
import { Client, Order } from 'constants/interface';
import { PaymentCategoryMapping } from 'constants/payment';
import { Input } from 'UI';
import { OrderOtherStatusEnum } from 'constants/order';

import {
  BaseFormItem,
  FormContainer,
  HorizontalContainer,
} from './style';

export interface ClientInfoFormData {
  client: string
  location: string
}

interface ClientInfoProps {
  formHandler: FormInstance<ClientInfoFormData>
  isLoading: boolean
  initialOrder?: Order
  isCopy?: boolean
}

const ClientInfo = ({
  formHandler,
  isLoading: externalLoading,
  initialOrder,
  isCopy = false,
}: ClientInfoProps): JSX.Element => {
  const [selectedClient, setSelectedClient] = useState<Client>();

  useEffect(() => {
    if (initialOrder?.id) {
      setSelectedClient(initialOrder.client);
    }
  }, [initialOrder?.id]);

  const isActiveOrderCanceled = initialOrder?.status === OrderOtherStatusEnum.CANCELED;

  const onClientSelect = (client?: Client) => {
    setSelectedClient(client);
    formHandler.setFieldsValue({
      location: undefined,
    });
  };

  return (
    <FormContainer
      form={formHandler}
      layout="vertical"
      requiredMark={false}
      initialValues={{
        client: initialOrder?.client.id,
        location: initialOrder?.location?.id,
      }}
    >
      <HorizontalContainer>
        <ClientSelectSearch
          onSelect={onClientSelect}
          form={{
            FormItem: BaseFormItem,
            formItemProps: {
              name: 'client',
              label: 'Cliente',
              rules: [{
                required: true,
                message: 'Selecione um cliente',
              }],
            },
          }}
          disabled={
            (isCopy === true)
              ? externalLoading
              : initialOrder !== undefined || externalLoading || isActiveOrderCanceled
          }
          initialClient={initialOrder?.client}
        />
        <LocationSelectSearch
          clientId={selectedClient?.id}
          form={{
            FormItem: BaseFormItem,
            formItemProps: {
              name: 'location',
              label: 'Localização',
            },
          }}
          initialSelected={initialOrder?.location}
          isDisabled={isActiveOrderCanceled}
        />
        <BaseFormItem
          label="Categoria"
        >
          <Input
            disabled
            value={`${selectedClient?.paymentCategory
              ? `${PaymentCategoryMapping[selectedClient.paymentCategory]}`
              : ''
            }`}
          />
        </BaseFormItem>
      </HorizontalContainer>
    </FormContainer>
  );
};

ClientInfo.defaultProps = {
  initialOrder: undefined,
};

export default ClientInfo;
